export type CommercialAttachProjectionRow = Readonly<{
  accountId: string; attached: boolean; benchmarkAttachAcvUsd: number;
}>;
type WhitespaceInput = { rows: Array<{ attached: boolean; benchmarkAttachAcvUsd: number }> };
export function projectCommercialEffectivenessAttachRows(rows: readonly CommercialAttachProjectionRow[]): {
  formulaInput: WhitespaceInput;
  dimensionalInputs: Array<{ sliceId: string; dimensions: { accountId: string }; input: WhitespaceInput }>;
} {
  const groups = new Map<string, CommercialAttachProjectionRow[]>();
  for (const row of rows) {
    const group = groups.get(row.accountId) ?? [];
    group.push(row);
    groups.set(row.accountId, group);
  }
  const input = (members: readonly CommercialAttachProjectionRow[]): WhitespaceInput => ({
    rows: members.map(row => ({ attached: row.attached, benchmarkAttachAcvUsd: row.benchmarkAttachAcvUsd })),
  });
  return { formulaInput: input(rows), dimensionalInputs: [...groups].map(([accountId, members]) => ({
    sliceId: `account:${accountId}`, dimensions: { accountId }, input: input(members),
  })) };
}
